/**
 * Review ID Generator Utility
 * 
 * Provides consistent review ID generation across all services.
 * Ensures unique IDs and prevents collisions.
 */

/**
 * Generate a unique review ID
 * @param {Object} reviewData - Review data (optional, for logging)
 * @returns {string} Unique review ID
 */
export function generateReviewId(reviewData = {}) {
  const timestamp = Date.now();
  const randomSuffix = Math.random().toString(36).substr(2, 9);
  
  const reviewId = `review-${timestamp}-${randomSuffix}`;
  
  // Optional: Log for debugging
  // Only log in development mode for debugging
  // Note: Removed console.log to prevent user data exposure
  
  return reviewId;
}

/**
 * Validate that a review ID is properly formatted
 * @param {string} reviewId - Review ID to validate
 * @returns {boolean} True if ID is valid
 */
export function isValidReviewId(reviewId) {
  return typeof reviewId === 'string' && 
         reviewId.startsWith('review-') && 
         reviewId.length > 20; // review-timestamp-randomstring
}

/**
 * Generate a review ID with fallback for existing reviews
 * @param {Object} review - Existing review object
 * @param {string} restroomId - Restroom ID
 * @param {number} index - Review index
 * @returns {string} Review ID
 */
export function ensureReviewId(review, restroomId, index) {
  // If review already has a valid ID, return it
  if (review.id && isValidReviewId(review.id)) {
    return review.id;
  }
  
  // Generate new ID for reviews without proper IDs
  console.log(`⚠️ Review missing proper ID, generating new one for restroom: ${restroomId}`);
  return generateReviewId(review);
}

export default {
  generateReviewId,
  isValidReviewId,
  ensureReviewId
};
